<div class="issue-container"
     (click)="navToIssue.emit(issueWithDetail())"
     data-testid="needs-attention-item">
     <img src="assets/icons/checkmark-circle-warning.svg"
          alt="Needs Attention" />
     <div class="info">
          <p [innerHTML]="issueWithDetail().issue.text"></p>
          <p class="subtext"
             [innerHTML]="issueWithDetail().subtext"></p>
     </div>
     <i class="pi pi-chevron-right"></i>
</div>